enum SnackbarSeverity {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export default SnackbarSeverity
